<template>
  <div
    style="
      background-color: #a52a2a;
      width: 100%;
      height: 100%;
      position: fixed;
    "
  >
    <div class="container">
      <div class="oops">404 Error</div>
      <div class="_404">
        <div style="margin-bottom: 20px">Sorry, page not found</div>
        <div class="mt-n6 mb-5">
          The page you we're looking for doesn't exist.
        </div>
        <v-btn
          @click="redirectTo()"
          rounded="xl"
          size="x-large"
          class="elevation-12"
          color="#2196F3"
          style="color: white"
          >back to homepage</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    redirectTo() {
      this.$router.push(
        "/" + this.getType(this.$store.state.user.usertype.id) + "/dashboard",
      );
    },
    getType(utype) {
      let type = "";
      if (utype == 1) {
        type = "superadmin";
      }
      if (utype == 2) {
        type = "admin";
      }
      if (utype == 3) {
        type = "ojt-coordinator";
      }
      if (utype == 4) {
        type = "instructor";
      }
      if (utype == 5) {
        type = "dean";
      }
      if (utype == 6) {
        type = "vpaa";
      }
      if (utype == 7) {
        type = "organization";
      }
      if (utype == 8) {
        type = "student";
      }
      return type;
    },
  },
};
</script>
<style scoped>
.container {
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
}
.oops {
  position: relative;
  width: 100%;
  font-size: 10rem;
  text-align: center;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  margin: auto;
}

._404 {
  width: 100%;
  display: grid;
  font-size: 20px;
  text-align: center;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  margin: auto;
}
</style>
